// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2sQ2P","loginScreen":"Logo_loginScreen__2iZhI","inverted":"Logo_inverted__1E46K","actions":"Logo_actions__XYq5z"};